import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TaskThick = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="Icons">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.90271 1.1528C1.93621 1.1528 1.15271 1.93631 1.15271 2.9028V13.0974C1.15271 14.0639 1.93621 14.8474 2.90271 14.8474H13.0973C14.0638 14.8474 14.8473 14.0639 14.8473 13.0974V2.9028C14.8473 1.9363 14.0638 1.1528 13.0973 1.1528H2.90271ZM2.65271 2.9028C2.65271 2.76473 2.76464 2.6528 2.90271 2.6528H13.0973C13.2354 2.6528 13.3473 2.76473 13.3473 2.9028V13.0974C13.3473 13.2355 13.2354 13.3474 13.0973 13.3474H2.90271C2.76464 13.3474 2.65271 13.2355 2.65271 13.0974V2.9028ZM11.471 6.1285C11.717 5.79527 11.6463 5.32568 11.3131 5.07966C10.9799 4.83363 10.5103 4.90432 10.2642 5.23755L7.11176 9.50741L5.42383 7.97822C5.11685 7.70011 4.64256 7.72352 4.36445 8.03049C4.08635 8.33746 4.10975 8.81176 4.41673 9.08986L6.71911 11.1757C6.87619 11.318 7.08615 11.3872 7.29706 11.3662C7.50797 11.3452 7.70013 11.2359 7.82603 11.0654L11.471 6.1285Z"
          fill={color}
        />
      </g>
    </svg>
  )
})

export default TaskThick
